import React from 'react';
import { joinClassNames } from '../../../utils/commonUtils';
import { Tooltip } from 'react-tooltip';

interface BadgeProps {
  label: string;
  tooltip?: string;
  colorScheme?: 'default' | 'error' | 'success' | 'warning';
}

export const Badge = ({ label, colorScheme = 'default', tooltip }: BadgeProps) => {
  const tooltipId = `badge-tooltip-${label}-${colorScheme}`;
  return (
    <>
      {!!tooltip && <Tooltip id={tooltipId} delayShow={1000} delayHide={500} />}
      <div
        data-tooltip-id={tooltipId}
        data-tooltip-content={tooltip}
        className={joinClassNames(
          // ! We may need to clean this css. Group seems to do nothing. Also optimise the colorScheme definition.
          'badge-base',
          colorScheme === 'error'
            ? 'badge-status-error'
            : colorScheme === 'success'
            ? 'badge-status-success'
            : colorScheme === 'warning'
            ? 'badge-status-warning'
            : 'badge-status-default',
        )}
      >
        {label}
      </div>
    </>
  );
};
